import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { menuAnatomy } from "@chakra-ui/react/anatomy";

export default defineSlotRecipe({
  slots: menuAnatomy.keys(),
  base: {
    // Chakra base puts Menu.content on l2 (controls tier); we lift it to
    // l3 so menus, popovers, and hovercards all read as the same kind of
    // floating surface.
    content: {
      borderRadius: "l3",
    },
  },
});
